import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconUpload',
  props: {
    classFill: null,
    className: null,
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "58.443",
    height: __props.size || 54,
    viewBox: "0 0 58.443 54",
    class: _normalizeClass(__props.className)
  }, [
    _createElementVNode("path", {
      id: "Path_7843",
      class: _normalizeClass(__props.classFill),
      "data-name": "Path 7843",
      d: "M187.113,104.03a14.917,14.917,0,0,1-3.9,\n      10.032,14.276,14.276,0,0,1-9.578,4.727c-.034,\n      0-.068,0-.1,0h-8.977a1.447,1.447,0,1,1,\n      0-2.894h8.924a11.954,11.954,0,0,0,1.138-23.613,\n      1.447,1.447,0,0,1-1.2-1.289,13.964,13.964,0,0,\n      0-26.527-4.6,1.446,1.446,0,0,1-1.812.74,6.1,6.1,\n      0,0,0-2.128-.375,6.254,6.254,0,0,0-6.247,6.247,\n      6.136,6.136,0,0,0,.375,2.141,1.448,1.448,0,0,1-.628,\n      1.753,9.881,9.881,0,0,0-4.89,8.5c0,5.39,4.252,10.183,\n      9.293,10.487h10.362a1.447,1.447,0,0,1,0,2.894h-10.4l-.08,\n      0a12.375,12.375,0,0,1-8.586-4.316,13.713,13.713,0,0,\n      1-3.478-9.061,12.791,12.791,0,0,1,5.363-10.383,\n      9.151,9.151,0,0,1,10.812-10.961,16.858,16.858,0,\n      0,1,31.321,5.591,14.87,14.87,0,0,1,10.947,\n      14.371Zm-21.59,2.793a1.447,1.447,0,0,0,\n      2.046-2.046l-8.653-8.654a1.447,1.447,0,0,\n      0-2.046,0l-8.654,8.653a1.447,1.447,0,0,0,\n      2.046,2.046l6.185-6.185v27.415a1.447,1.447,\n      0,1,0,2.894,0V100.638Z",
      transform: "translate(-128.67 -75.5)",
      fill: "#0079AF"
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})